import React from "react";
import { BadgeWrapper, HugeAvatar } from "components/Base";
import CSSModules from "react-css-modules";
import css from "./OpacityTrigger.css";

/**
 * Note: TogglableStar was removed from the avatar per Product's request.
 * The feature can be enabled again adding a component wrapped with makeTopLeftBadge(TogglableStar)
 */
const StarrableHugeAvatar = CSSModules(
  ({ id, name }) => (
    <BadgeWrapper styleName={"parentContainer"}>
      <HugeAvatar id={id} text={name} square longInitials />
    </BadgeWrapper>
  ),
  css
);

export default StarrableHugeAvatar;
